import { AlphaLCircleIcon } from './AlphaLCircleIcon';

/**
 * author: Contributors
 * id B1456398-80C2-4D10-B7D3-A79BE026E457
 * name alpha-l-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-l-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterLCircleIcon = AlphaLCircleIcon;
export default LetterLCircleIcon